<template>
  <div class="header">
    <div class="header-content">
      <DownloadBox v-if="!isMobile && isHomePage" @headerPositionBrowser="headerPositionBrowser"></DownloadBox>
      <v-app-bar id="headerBar" flat class="header-wrap" height="48">
        <div class="header-title white--text">
          <v-toolbar-title class="logo-wrap" @click="navigatePush('home')">
            <img src="@/assets/images/nav/grx-logo.svg" alt="grx" />
          </v-toolbar-title>
        </div>

        <div class="header-items-wrap d-md-flex align-center hidden-sm-and-down">
          <a
            v-for="(item, index) in headerMenu"
            @click="navigatePush(item.routeName)"
            :key="index"
            class="header-item"
            :class="{ 'header-item-active': $route.name === item.routeName }"
            >{{ item.name }}</a>
        </div>

        <div class="avatar-wrap d-md-flex align-center hidden-sm-and-down">
          <div class="header-items-wrap d-lg-flex align-center hidden-md-and-down">
            <template v-for="(item, index) in headerRightMenu">
              <template v-if="!item.requireAuth || (item.requireAuth && Getter_Token)">
                <a
                  v-if="item.navType === 'text'"
                  @click="navigatePush(item.routeName)"
                  :key="index"
                  class="header-item"
                  :class="{ 'header-item-active': $route.name === item.routeName }"
                  >{{ item.name }}</a
                >
                <SelectNav v-else-if="item.navType === 'select'" :key="index" :group-name="item.name" :options="item.options" />
                <CurrencyToggle v-else-if="item.navType === 'currency'" :key="index" />
                <LangToggleHeader v-else-if="item.navType === 'lang'" :key="index" />
              </template>
            </template>
          </div>
          <!-- <UserDropdown v-if="Getter_Token" /> -->
          <div v-if="Getter_Token" class="icon-wrap" @click="navigatePush('messages')">
            <img class="cursor" :src="require('@/assets/images/home/notice.svg')" width="24" height="24" alt="" />
            <span class="sup-count" v-if="unreadCount !== undefined && unreadCount != '0'">{{ unreadCount }}</span>
          </div>
          <UserInfoDrop v-if="Getter_Token" />
          <div v-else class="header-right-wrap d-flex">
            <div class="mx-2">
              <v-btn @click="navigatePush('register')" block class="btn btn-white register-btn">
                {{ $t('actions.register') }}
              </v-btn>
            </div>
            <div class="mx-2">
              <v-btn @click="navigatePush('login')" block class="btn btn-common login-btn">
                {{ $t('actions.login') }}
              </v-btn>
            </div>
          </div>
        </div>
        <!-- </div> -->

        <!-- Mobile Header Menu Icon and Navigation Drawer -->
        <div
          v-if="$vuetify.breakpoint.mdAndDown"
          class="burger-body"
          :class="{ change: Getter_Burger_Menu_State, 'ml-auto': $vuetify.breakpoint.smAndDown }"
          @click="setSideBarState"
        >
          <div id="burgerMenu" class="burger-menu">
            <div class="line line-1"></div>
            <div class="line line-2"></div>
            <div class="line line-3"></div>
          </div>
        </div>
        <HeaderMenu :count="unreadCount"></HeaderMenu>
      </v-app-bar>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import { actionTypes } from '@/store/action-types';
import { mutationTypes } from '@/store/mutation-types';
import { getterTypes } from '../../store/getter-types';
// import UserDropdown from './UserDropdown';
import UserInfoDrop from './UserInfoDrop';
import CurrencyToggle from '@/components/CurrencyToggle/CurrencyToggle';
import SelectNav from '@/components/SelectNav';
import LangToggleHeader from '@/components/LangToggle/LangToggleHeader';
import DownloadBox from '@/components/DownloadBox/DownloadBox';
import tool from '@/common/js/tool.js';
import HeaderMenu from '../../components/Header-Menu/HeaderMenu';
import { messagesApi } from '@/api/user/messagesApi';

export default {
  name: 'DefaultHeader',
  components: {
    // UserDropdown,
    CurrencyToggle,
    SelectNav,
    LangToggleHeader,
    DownloadBox,
    HeaderMenu,
    UserInfoDrop
  },
  data() {
    return {
      unreadCount: '0',
      headerMenu: [
        { name: this.$t('header.markets'), routeName: 'markets', navType: 'text' },
        { name: this.$t('header.exchange'), routeName: 'exchange', navType: 'text' },
        { name: this.$t('header.announcement'), routeName: 'announcement', navType: 'text' },
        { name: this.$t('header.helpCenter'), routeName: 'help', navType: 'text' },
        // { name: this.$t('STO'), routeName: 'sto-listing', navType: 'text' }
      ],
      headerRightMenu: [
        {
          name: this.$t('header.assets'),
          routeName: 'markets',
          navType: 'select',
          requireAuth: true,
          options: [{ name: this.$t('labels.finance.coinToCoinAcc'), path: 'coinToCoinAccount' }]
        },
        {
          name: this.$t('header.orders'),
          routeName: 'exchange',
          navType: 'select',
          requireAuth: true,
          options: [{ name: this.$t('labels.trade.coinOrders'), path: 'orders' }]
        },
        {
          name: 'CurrencyToggle',
          navType: 'currency'
        },
        {
          name: 'LangToggleHeader',
          navType: 'lang'
        }
      ],
      isMobile: false,
      isHomePage: false
    };
  },
  computed: {
    ...mapGetters([
      getterTypes.Getter_Token,
      getterTypes.Getter_Burger_Menu_State,
      getterTypes.Getter_Unread_Message_Count,
      getterTypes.Getter_For_Mobile
    ])
  },
  watch: {
    Getter_Unread_Message_Count: {
      immediate: true,
      handler() {
        if (this.Getter_Token) {
          messagesApi.getUnreadNotificationsCount().then(res => {
            this.SET_UNREADMESSAGECOUNT = res.data;
            this.unreadCount = res.data;
          });
        }
      }
    },
    $route() {
      this.isHomePage = this.$route.path === '/';
      if (this.isHomePage) {
        //document.getElementById("burgerMenu").style.top = "80px";
      }
    }
  },
  methods: {
    ...mapMutations([mutationTypes.SET_BURGER_MENU_STATE]),
    headerPositionBrowser(val) {
      //document.getElementById('burgerMenu').style.top = null;
      if (val) document.getElementById('headerBar').style.position = 'relative';
      else document.getElementById('headerBar').style.position = 'fixed';
    },
    setSideBarState() {
      this.SET_BURGER_MENU_STATE(!this.Getter_Burger_Menu_State);
    }
  },
  mounted() {
    if (this.$route.query.isMobile !== undefined) {
      this.isMobile = true;
    }
    this.isHomePage = this.$route.path === '/';
    // if (this.isHomePage) {
    //   document.getElementById('burgerMenu').style.top = '80px';
    // }
    if (!this.isMobile) {
      //document.getElementById('burgerMenu').style.top = '80px';
    }
  }
};
</script>

<style lang="stylus" scoped>
.theme--light {
  .header {
    position: relative;
    height: 48px;

    .header-content {
      position: fixed;
      width: 100%;
      z-index: 100;
    }
  }

  &.v-app-bar {
    .header-title {
      margin-right: 20px;
      cursor: pointer;

      .header-logo {
        width: 100%;
        max-width: 150px;
      }
    }

    &.header-wrap {
      background-color: var(--header-color) !important;
      z-index: 100;

      .logo-wrap {
        width: 150px;
        height: 50px;
        padding: 0 5px;
        display: flex;
        align-items: center;
      }

      .header-items-wrap {
        .header-item {
          color: #ffffff;
          font-size: 0.85rem;
          margin-right: calc(var(--gap) * 0.5);
          text-decoration: none;
          padding: 16px 10px;
          position: relative;

          &::before {
            position: absolute;
            display: block;
            content: '';
            width: 100%;
            height: 2px;
            background-color: #fff;
            left: 0;
            bottom: 5px;
            opacity: 0;
            transition: all 0.3s;
          }

          &-active::before {
            opacity: 1;
          }
        }
      }

      .avatar-wrap {
        margin-left: auto;

        .avatar-btn {
          cursor: pointer;
        }
      }

      .icon-wrap {
        display: flex;
        padding: 0 12px;
        position: relative;

        .sup-count {
          min-width: 16px;
          height: 16px;
          font-size: 12px;
          border-radius: 2px;
          background: rgba(56, 92, 173, 1);
          position: absolute;
          top: 0;
          right: 10px;
          transform: translate(40%, -40%);
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
        }
      }

      .header-right-wrap {
        .btn {
          letter-spacing: 0px;
        }
      }
    }

    /* Remove hover effect */
    .x-hover::before {
      color: transparent;
    }
  }

  .btn-white {
    background-color: #ffffff;
    color: var(--btn-main-color);
  }

  .profile-wrap {
    cursor: pointer;
    user-select: none;
  }

  .burger-body {
    display: none;
  }

  .register-btn {
    height: 30px !important;
  }

  .login-btn {
    height: 30px !important;
  }
}

@media screen and (max-width: 1263px) {
  .theme--light {
    .burger-body {
      display: flex;
      justify-content: center;
      align-items: center;
      transition: right 0.9s cubic-bezier(1, 0, 0, 1);
      height: 44px;
      width: 44px;
      border-radius: 50%;
      z-index: 100;
      background-color: var(--header-color);
    }

    .burger-menu {
      width: 20px;
      height: 20px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      z-index: 100;
    }

    .line {
      width: 100%;
      height: 2px;
      border-radius: 50px;
      background-color: #fff;
      transition: all 0.3s;
    }

    .change .line-1 {
      transform: rotateZ(45deg) translate(5px, 5px);
    }

    .change .line-2 {
      opacity: 0;
    }

    .change .line-3 {
      transform: rotateZ(-45deg) translate(5px, -5px);
    }
  }
}
</style>
